export { default } from "../src/get";
